module.exports = __webpack_public_path__ + "static/img/4.112d9251.png";